import { useState } from 'react';
import { GRID_BREAKPOINT_LARGE } from '../constants/sizes';
export function useScreenSize() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.matchMedia(`(max-width: ${GRID_BREAKPOINT_LARGE})`).matches);
  const mediaQuery = window.matchMedia(`(max-width: ${GRID_BREAKPOINT_LARGE})`);
  mediaQuery.addEventListener('change', e => {
    if (e.matches) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  });
  return isSmallScreen;
}